import React from 'react';
import { useForm, SubmitHandler, useFormContext } from 'react-hook-form';

import { Input } from 'app/components/ui/input';
import { Button } from 'app/components/ui/button';
import { toast } from 'app/components/ui/use-toast';
import { useProductsSlice } from '../../slice';
import { Select } from '@radix-ui/react-select';

const TagForm = () => {
  const form = useFormContext();

  return (
    <div className="space-y-3">
      <div>
        <label className="mb-2 text-sm flex">Tag Name</label>
        <Input
          type="text"
          placeholder="Enter Tags name"
          {...form.register('tag_name', {
            required: 'Category name is required',
          })}
          onChange={e => {
            form.setValue(
              'slug',
              e.target.value.toLowerCase().replace(/ /g, '-'),
            );
          }}
        />
        {form.formState.errors.tag_name && (
          <p className="text-red-500 text-sm">
            {form.formState.errors.tag_name.message}
          </p>
        )}
      </div>

      <div>
        <label className="text-sm mb-2 flex">Slug</label>
        <Input
          type="text"
          {...form.register('slug', { required: 'Slug is required' })}
        />
        {form.formState.errors.slug && (
          <p className="text-red-500 text-sm">
            {form.formState.errors.slug.message}
          </p>
        )}
      </div>
    </div>
  );
};

export default TagForm;
